@if (visibleKeys.length > 0) {
	<div class="filter-panel">
		<div class="filter-panel-header" (click)="expanded.set(!expanded())" (keydown.enter)="expanded.set(!expanded())" tabindex="0" role="button" data-testid="property-filter-panel-toggle">
			<span class="filter-panel-title">{{ title() }}</span>
			<i [class]="expanded() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
		</div>
		@if (expanded()) {
			<div class="filter-panel-content">
				@for (key of visibleKeys; track key) {
					<div class="filter-item">
						<label class="filter-key" [for]="'filter-select-' + key">{{ formatKey(key) }}</label>
						<p-select
							[inputId]="'filter-select-' + key"
							[options]="optionsFn()(key)"
							optionLabel="label"
							optionValue="value"
							[ngModel]="getFilterValue(key)"
							(ngModelChange)="onFilterChange(key, $event)"
							placeholder="All"
							[filter]="true"
							filterPlaceholder="Search..."
							[showClear]="true"
							[style]="{ width: '100%' }"
							[attr.data-testid]="'property-filter-' + key + '-select'"
						/>
					</div>
				}
			</div>
		}
	</div>
}
